import { Locale } from '@enmon/commons';
import { SHARED_TRANSLATION_MESSAGES, type TranslationDictionary } from '@enmon-monorepo/i18n';

const APP_TRANSLATION_MESSAGES: Record<Locale, TranslationDictionary> = {
  [Locale.CS]: {},
  [Locale.EN]: {},
  [Locale.SK]: {},
  [Locale.PL]: {},
};

export const TRANSLATION_MESSAGES: Record<Locale, TranslationDictionary> = {
  [Locale.CS]: { ...SHARED_TRANSLATION_MESSAGES[Locale.CS], ...APP_TRANSLATION_MESSAGES[Locale.CS] },
  [Locale.EN]: { ...SHARED_TRANSLATION_MESSAGES[Locale.EN], ...APP_TRANSLATION_MESSAGES[Locale.EN] },
  [Locale.SK]: { ...SHARED_TRANSLATION_MESSAGES[Locale.SK], ...APP_TRANSLATION_MESSAGES[Locale.SK] },
  [Locale.PL]: { ...SHARED_TRANSLATION_MESSAGES[Locale.PL], ...APP_TRANSLATION_MESSAGES[Locale.PL] },
};
